// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"editor_tabContent__19zfr","textComponent":"editor_textComponent__j2fE9","callToAction":"editor_callToAction__1N7ET"};